<template>
	<section
		:id="item.id"
		:data-article-category="className"
		:data-article-type="item.resourceType"
	>
		<div class="card-wrapper">
			<router-link
				:to="`/marketing-resources-details/${item.marketingResourceId}`"
				:aria-label="`view ${item.name} ${item.resourceType}`"
				class="card-link"
			>
				<img :src="item.previewUri" :alt="item.summary" />
			</router-link>
		</div>
		<h2>{{ item.name }}</h2>
		<p class="description" v-if="item.resourceType != 'viewall'">
			{{ item.summary | truncate(item.resourceType) }}
			<router-link
				:to="`/marketing-resources-details/${item.marketingResourceId}`"
				class="learn-more"
				:aria-label="`learn more about ${item.name}`"
				>Learn more</router-link
			>
		</p>
	</section>
</template>

<script>
export default {
	name: 'ResourceCard',
	props: {
		item: Object,
		className: String,
	},
	filters: {
		truncate(content, contentType) {
			if (!content) return '';
			const value = content.toString();
			if (contentType === 'video') {
				return `${value.substring(0, 82)}...`;
			}
			if (contentType === 'document') {
				return `${value.substring(0, 18)}...`;
			}
			return value;
		},
		lowerCase(content) {
			return content || content === 0
				? content.toString().toLowerCase().trim()
				: '';
		},
	},
};
</script>

<style lang="scss" scoped>
article {
	&.swiper-slide {
		margin-right: unset;
		transform: scale(1);
		height: 100%;
		position: relative;
		box-sizing: border-box;
		@include rem(margin-left, 30px);
		width: unset;
		border: 2px solid transparent;
		transition: all $b360-motion-duration--long
			$b360-motion-easing--accelerate;

		&:not(:last-child):hover {
			transform: scale(1.05);
		}

		@include mobile {
			margin-left: unset;
			@include rem(margin-right, 25px);
		}
	}

	.card-wrapper {
		width: 240px;

		@include mobile {
			width: 300px;
		}

		@include mobile-min {
			width: 270px;
		}
	}

	[data-article-type='document'],
	[data-article-type='document'] .card-wrapper {
		width: 140px;

		figure {
			margin: unset;
			height: 100%;
		}
	}

	[data-article-type='Video'] {
		@include rem(width, 354px);
		@include rem(margin-bottom, 25px);

		@include mobile {
			width: unset;
		}
	}

	[data-article-type='Video'] .card-wrapper {
		display: flex;
		justify-content: center;
		width: 354px;

		@include mobile {
			width: unset;
		}
	}

	[data-article-type='viewall'] .card-wrapper {
		display: flex;
		justify-content: center;
		width: 140px;
		border: 1px solid $border-color-light;
		color: $brand-blue;

		svg {
			font-size: 48px;
			color: $brand-blue;
		}

		a {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			text-decoration: none;

			figure {
				display: flex;
				flex-wrap: wrap;

				.view-all-text {
					text-decoration: none;
					color: $brand-blue;
				}
			}
		}
	}

	[data-article-category='Quick Talks'] .card-wrapper {
		background-color: $brand-blue;
	}

	[data-article-category='Tutorials'] .card-wrapper {
		background-color: $b360-color--orange__light;
	}

	[data-article-category='Walk-Throughs'] .card-wrapper {
		background-color: $b360-color--green;
	}

	[data-article-category='Job Aids'] .card-wrapper {
		background-color: $b360-color--teal;
	}

	.card-wrapper {
		position: relative;
		height: 200px;
		border-radius: $b360-border-radius-base;

		video,
		img,
		.card-link {
			width: 100%;
			height: 100%;
			border-radius: $border-radius;
			cursor: pointer;
			object-fit: cover;
		}

		.notification {
			@include rem(padding, 5px);
			border-radius: $b360-border-radius-base;
			position: absolute;
			bottom: 11px;
			left: 11px;

			&.new {
				background-color: $b360-color--orange;
				color: $white;
				@include typo--roboto__bold;
				@include rem(font-size, 12px);
				@include rem(line-height, 12px);
			}
		}
	}

	h2 {
		@include rem(font-size, 17px);
		@include typo--roboto__medium;
		@include rem(line-height, 17px);
		@include rem(margin, 20px 0 10px 0);
	}

	p {
		@include rem(font-size, 15px);
		@include typo--roboto__regular;
		color: $b360-color--gray__darkest;
		padding: 0 0 10px 0;
	}

	.learn-more {
		color: $brand-blue;
		text-decoration: none;
		@include typo--roboto__medium;

		&:hover,
		&:focus {
			text-decoration: underline;
		}
	}
}
</style>
